import EventEmitter from 'events';

const EventBus = new EventEmitter();
EventBus.setMaxListeners(0);

export { EventBus };

export default (ctx, inject) => {
  inject('EventBus', EventBus);
};
